module.exports = __webpack_public_path__ + "img/BD.71d377c3.svg";